// UX46: tracks when the user last loaded the feed, so we can surface
// a "catch-up" card on return visits showing how many new polls have
// landed since. Stored in localStorage per-browser (not per-pubkey) —
// matches the quillStreak model: the hint is for *this device*, not
// an achievement tied to identity.
//
// Value is a UNIX seconds timestamp (same unit as Nostr created_at /
// our item.postedAt) so comparisons with feed items need no unit
// conversion.

const LS_LAST_SEEN_FEED = 'verdant_last_seen_feed'

export function loadLastSeen() {
  try {
    const raw = localStorage.getItem(LS_LAST_SEEN_FEED)
    if (!raw) return null
    const n = Number(raw)
    return Number.isFinite(n) && n > 0 ? n : null
  } catch {
    return null
  }
}

export function markSeenNow() {
  try {
    localStorage.setItem(LS_LAST_SEEN_FEED, String(Math.floor(Date.now() / 1000)))
  } catch { /* noop */ }
}
